import React, { PureComponent } from 'react';
import {Drawer,} from 'antd';
import {NewBuyerLabel,TransactionCustomerStage,InternalBuyerLabel} from "./statuBuyerLabel"
import Lang from "@/components/Lang/Lang";
import FollowUpDrawer from "@components/FollowUp/FollowUpDrawer"
import FollowHistoryList from "../FollowUp/FollowHistoryList/FollowHistoryList";
import FollowStage from "./FollowStage/FollowStage";
import "./FollowStage/followStageDrawer.less"
/**
 * Essaone 新客户标签类型
 *
 * */
export default class NewBuyerLabelAndHistoryDrawer extends PureComponent {
    static defaultProps = {
        buyerId:"",
        statusCode:"",
        className:"",
        status:"",
        labelType:"",
        showDrawer:false,
    };
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        }
    }
     showDrawer = (flag) => {
         this.setState({
             open:flag
         })
        if(flag){
            this.openFollowUpDrawer(false)
        }
    };
    openFollowUpDrawer(flag){
        this.setState({
            visibleFollowUpDrawer:flag
        })
        if(flag){
            if (this.childRefDrawer) {
                this.childRefDrawer.getCustomer()
            }
            setTimeout(()=>{
                // 保存成功 改为跳回列表
                this.showDrawer(false)
            },400)

        }
    }
    successCallBack(){
        if(this.props.reRefreshSearch){
            this.props.reRefreshSearch();
        }
    }
    childRef = (ref) =>  this.childRefDrawer = ref;
    render() {
        const {buyerId,labelType,statusCode,className,status,} = this.props;
        const {open=false,visibleFollowUpDrawer=false} = this.state;
        {/* 产品要求 不能重复叠加抽屉 */}
        return (
            <>
                {
                    labelType=="1010"&&labelType=="1020"?
                        <span onClick={()=>this.showDrawer(true)}>
                            {/* //1010:新客标签 1020:成交客户标签 */}
                            {labelType=="1010"&&<NewBuyerLabel
                                className={"cursor-p"} statusCode={statusCode} status={status} />}
                            {labelType=="1020"&&<TransactionCustomerStage
                                className={"cursor-p"} statusCode={statusCode} status={status} />}

                         </span>:
                         <InternalBuyerLabel className={"cursor-p"} statusCode={statusCode} status={status} />
                }

                {buyerId? <Drawer title={<div className={"font_18 fw_500 lineH_27"}>{Lang({id:"KeHuGenJinJieDuan",default:"客户跟进阶段"})}</div>}
                                  width={1100}
                                  rootClassName={"followStageDrawer"}
                                  destroyOnClose={true}
                                  onClose={()=>this.showDrawer(false)}
                                  open={open}>
                            <div className={"flex-item"}>
                                <div className={"leftCon black89 font_14"}>
                                     {open&&<FollowStage buyerId={buyerId} labelType={labelType}
                                                         successCallBack={()=>this.successCallBack()} />}
                                </div>
                                <div className={"historyList ml_8"}>
                                    {open&&<FollowHistoryList buyerId={buyerId} openDrawerCallBack={()=>this.openFollowUpDrawer(true)} />}
                                </div>
                            </div>
                </Drawer>:null}
                <FollowUpDrawer buyerId={buyerId}
                                labelType={labelType}
                                onRef={this.childRef}
                                visibleFollowUpDrawer={visibleFollowUpDrawer}
                                showDrawer={(flag)=>this.openFollowUpDrawer(flag)} />
            </>
        );
    }


};
